import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

function ThankYou() {
  const navigate = useNavigate();

  return (
    <div className="app">
      {/* Navigation */}
      <nav className="nav">
        <div className="nav-container">
          <div className="nav-logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>
            <span className="logo-text">AmsWeb</span>
            <span className="logo-subtitle">Aide MultiServices du Web</span>
          </div>
          <div className="nav-links">
            <a href="/" className="nav-link">Accueil</a>
            <a href="/formations-outils" className="nav-link">Nos Ressources</a>
            <a href="/#blog" className="nav-link">Blog</a>
            <a href="/#contact" className="nav-link nav-cta">Contact</a>
          </div>
        </div>
      </nav>

      {/* Thank You Content */}
      <section className="thankyou-section">
        <div className="container">
          <div className="thankyou-content">
            <div className="thankyou-icon">🎉</div>
            <h1 className="thankyou-title">Félicitations ! Tu as fait le premier pas 🚀</h1>
            <p className="thankyou-subtitle">
              Merci pour ta confiance ! On est super content de t'accueillir dans la communauté AmsWeb.
            </p>

            {/* Lead Magnet Download */}
            <div className="leadmagnet-box">
              <div className="leadmagnet-icon">📥</div>
              <h2>Ton Cadeau de Bienvenue est Prêt !</h2>
              <p>Télécharge dès maintenant ton guide gratuit :</p>
              <div className="leadmagnet-title">
                <strong>"Les 7 Erreurs Fatales en MLM<br />et Comment les Éviter"</strong>
              </div>
              <a 
                href="/guide-mlm-amsweb.pdf" 
                download="Guide-7-Erreurs-MLM-AmsWeb.pdf"
                className="btn btn-primary btn-large"
                data-testid="download-lead-magnet"
              >
                📥 Télécharger Mon Guide Gratuit
              </a>
              <p className="leadmagnet-note">
                ⚡ Ce guide va te faire économiser des mois d'erreurs coûteuses !
              </p>
            </div>

            {/* What's Next */}
            <div className="whats-next">
              <h2>🎯 Et Maintenant ?</h2>
              <div className="steps-grid-thankyou">
                <div className="step-thankyou">
                  <div className="step-number-thankyou">1</div>
                  <h3>📧 Check ton email</h3>
                  <p>Tu vas recevoir un email de ma part dans les 2 prochaines minutes avec des infos exclusives.</p>
                </div>
                <div className="step-thankyou">
                  <div className="step-number-thankyou">2</div>
                  <h3>📖 Lis le guide</h3>
                  <p>Découvre les 7 erreurs que font 90% des networkers débutants.</p>
                </div>
                <div className="step-thankyou">
                  <div className="step-number-thankyou">3</div>
                  <h3>🚀 Passe à l'action</h3>
                  <p>Dans les prochains jours, je vais te partager ma stratégie unique et mes meilleures formations.</p>
                </div>
              </div>
            </div>

            {/* Preview Formations */}
            <div className="preview-formations">
              <h2>🎓 Aperçu de Nos Formations Exclusives</h2>
              <p className="preview-subtitle">
                Tu recevras bientôt tous les détails par email, mais voici un avant-goût...
              </p>
              <div className="formations-preview-grid">
                <div className="formation-preview-card">
                  <div className="formation-preview-icon">🎯</div>
                  <h3>Outil de Prospection Massive</h3>
                  <p>La technique pour prospecter massivement sur Internet sans spam et avec des résultats.</p>
                </div>
                <div className="formation-preview-card">
                  <div className="formation-preview-icon">🥷</div>
                  <h3>L'École du Networker</h3>
                  <p>Formation complète pour maîtriser tous les aspects du networking et du MLM.</p>
                </div>
                <div className="formation-preview-card">
                  <div className="formation-preview-icon">⚙️</div>
                  <h3>Système.io</h3>
                  <p>L'outil tout-en-un utilisé par les pros pour automatiser et développer leur MLM.</p>
                </div>
              </div>
              <div className="preview-cta">
                <button 
                  onClick={() => navigate('/formations-outils')}
                  className="btn btn-secondary btn-large"
                  data-testid="view-all-formations"
                >
                  Voir Toutes Nos Formations 👀
                </button>
              </div>
            </div>

            {/* Reassurance */}
            <div className="reassurance-box">
              <p>💬 <strong>Une question ?</strong> Réponds simplement à l'email que tu vas recevoir, je te réponds personnellement !</p>
              <p>✉️ <a href="mailto:contact@amsweb.fr">contact@amsweb.fr</a></p>
            </div>

            <div className="thankyou-footer-note">
              <p><strong>À très vite,</strong></p>
              <p>Fred d'AmsWeb 😉</p>
              <div style={{marginTop: '2rem'}}>
                <a href="/" className="btn btn-secondary" data-testid="back-to-home">
                  ← Retour à l'accueil
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>AmsWeb</h3>
              <p>Aide MultiServices du Web</p>
            </div>
            <div className="footer-section">
              <h4>Navigation</h4>
              <ul className="footer-links">
                <li><a href="/">Accueil</a></li>
                <li><a href="/formations-outils">Formations & Outils</a></li>
                <li><a href="/#blog">Blog</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>✉️ <a href="mailto:contact@amsweb.fr">contact@amsweb.fr</a></p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 AmsWeb.fr - Tous droits réservés</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default ThankYou;